import { useNavigate } from "react-router-dom";
import { blogArticles, blogCardImages } from "@/mocks/categories";

export default function BlogSection() {
  const navigate = useNavigate();

  const handleArticleClick = (slug: string) => {
    if (slug !== "#") {
      navigate(slug);
      window.scrollTo({ top: 0, behavior: "smooth" });
    }
  };

  return (
    <section className="py-16 md:py-20 bg-background-100">
      <div className="px-6 md:px-12">
        <div className="text-center mb-12">
          <h2 className="text-2xl md:text-4xl font-heading font-bold text-foreground-950">
            Latest SEO Guides &amp; Reviews
          </h2>
          <p className="mt-3 text-foreground-600 text-sm md:text-base max-w-xl mx-auto">
            Expert tips, safety guides, and honest comparisons to help you make the best buying decisions
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {blogArticles.map((article, i) => {
            const imgSrc = blogCardImages[i] || blogCardImages[0];
            return (
              <div
                key={article.slug}
                onClick={() => handleArticleClick(article.slug)}
                className={`group relative rounded-xl overflow-hidden cursor-pointer transition-all duration-300 hover:shadow-md ${
                  article.slug !== "#" ? "" : "opacity-80"
                }`}
              >
                <div className="relative w-full aspect-[4/3]">
                  <img
                    src={imgSrc}
                    alt={article.title}
                    className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                    loading="lazy"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/75 via-foreground-950/15 to-transparent"></div>
                </div>
                <div className="absolute bottom-0 left-0 right-0 p-5">
                  <h3 className="text-base md:text-lg font-heading font-bold text-background-50 mb-1.5 leading-snug">
                    {article.title}
                  </h3>
                  <p className="text-xs md:text-sm text-background-50/80 leading-relaxed">{article.subtitle}</p>
                  <span className="inline-flex items-center gap-1 mt-3 text-xs font-medium text-accent-300 group-hover:text-accent-200 transition-colors">
                    Read Article <i className="ri-arrow-right-line text-sm"></i>
                  </span>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}